import { render } from "./About.vue?vue&type=template&id=3eb2190a"
const script = {}
script.render = render

export default script